module.exports = __webpack_public_path__ + "a7d34f71b51a26106e689f279534cae9.svg";